export default __webpack_public_path__ + "static/media/39.1ae90595.jpg";